import { AccordionItem, MinusCircleIcon, PlusCircleIcon } from '@cmsgov/design-system';
import { jsx as _jsx } from "preact/compat/jsx-runtime";
const HealthcaregovAccordionItem = function (props) {
  const {
    closeIconComponent = MinusCircleIcon,
    openIconComponent = PlusCircleIcon
  } = props;
  return /*#__PURE__*/_jsx(AccordionItem, {
    closeIconComponent: closeIconComponent,
    openIconComponent: openIconComponent,
    ...props
  });
};
export { HealthcaregovAccordionItem };